import { ApolloError } from '@apollo/client';
import { useAccommodationPropertyPhotosQuery } from '@graphql/generated';
import { addError } from '@shared/utils/logger';

export const useAccommodationPlacePhotos = (joyPlaceIds: string[]) => {
  const { data: accommodationPropertyPhotos, loading: loadingAccommodationPropertyPhotos } = useAccommodationPropertyPhotosQuery({
    variables: { payload: { propertyIdentifiers: joyPlaceIds?.map(id => ({ joyPlaceId: id })) } },
    onError(error: ApolloError) {
      addError(error, {
        source: 'Accommodation place photos api failed',
        context: 'searchAccommodationProperties',
        errorMessage: error.message,
        propertyIds: joyPlaceIds
      });
    },
    skip: !joyPlaceIds?.length,
    batchMode: 'fast'
  });

  return { accommodationPropertyPhotos, loadingAccommodationPropertyPhotos };
};
